// extracted by mini-css-extract-plugin
module.exports = {"slide":"TagManagmentListItem_slide_2vhIH","slide-reverse":"TagManagmentListItem_slide-reverse_2kIkO","editInput":"TagManagmentListItem_editInput_1s0Rg"};